import { ApiService } from "./ApiService";
import { SubscribeRateAgreementData } from "../types/SubscribeRateAgreementData";
import { SubscriptionVerificationData } from "../types/SubscriptionVerificationData";

const baseUrl = "/services/rateagreement/api/subscription";

class ReminderSubscriptionService extends ApiService {
    async subscribe(subscribeRateAgreement: SubscribeRateAgreementData): Promise<boolean> {
        const response = await fetch(baseUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(subscribeRateAgreement),
        });

        const subscribeResponse = await this.handleResponse(response);
        return (await subscribeResponse.json()) as boolean;
    }

    async verifyCode(subscriptionVerificationData: SubscriptionVerificationData): Promise<boolean> {
        const response = await fetch(baseUrl + "/verify", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(subscriptionVerificationData),
        });
        const verifyResponse = await this.handleResponse(response);
        return (await verifyResponse.json()) as boolean;
    }
}

export default new ReminderSubscriptionService();
